export enum HaulerTemplateSectionEnum {
  Ticket = 'Ticket',
  Pickup = 'Pickup',
  Delivery = 'Delivery',
  Customer = 'Customer',
  Driver = 'Driver',
}
